import React from "react"
import {Container, ImagePlaceholder} from "./component"
import {getMeganavIconPath} from "../../utils/getCdnUrl"
import {Icons} from "../../models/secondary-nav"
import {
    DEFAULT_IMAGE_PLACEHOLDER,
    DEFAULT_IMAGE_PLACEHOLDER_2X,
    DEFAULT_IMAGE_PLACEHOLDER_3X,
} from "../../config/constants"
import connect from "./connect"
import {prefixImagePath} from "../../utils/prefixPath"

export type IconProps = {
    icons: Icons[] | undefined
    realm: string
    siteUrl: string
    meganavCircularIconsEnabled: boolean
}

export const SnailItemIcon = ({icons, realm, siteUrl, meganavCircularIconsEnabled}: IconProps) => {
    if (!meganavCircularIconsEnabled) return null

    const icon1xRes =
        icons?.length && icons[0] && icons[0].url.length ? prefixImagePath(siteUrl)(icons[0].url) : undefined
    const icon2xRes =
        icons?.length && icons[1] && icons[1].url.length ? `${prefixImagePath(siteUrl)(icons[1].url)} 2x` : undefined
    const icon3xRes =
        icons?.length && icons[2] && icons[2].url.length ? `, ${prefixImagePath(siteUrl)(icons[2].url)} 3x` : undefined

    const imageOnErrorHandler = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.onerror = null
        e.currentTarget.src = `${getMeganavIconPath(DEFAULT_IMAGE_PLACEHOLDER, realm)}`
        e.currentTarget.srcset = `${getMeganavIconPath(DEFAULT_IMAGE_PLACEHOLDER_2X, realm)} 2x, ${getMeganavIconPath(
            DEFAULT_IMAGE_PLACEHOLDER_3X,
            realm,
        )} 3x`
    }

    return (
        <Container>
            <ImagePlaceholder
                src={icon1xRes || `${getMeganavIconPath(DEFAULT_IMAGE_PLACEHOLDER, realm)}`}
                srcSet={`${icon2xRes || ""}${icon3xRes || ""}`}
                alt=""
                data-testid={`meganav-secondary-nav-small-screen-image-${icon1xRes ? "icon" : "placeholder"}`}
                onError={imageOnErrorHandler}
            />
        </Container>
    )
}

export default connect(SnailItemIcon)
